import { useHasProAccess } from '../../../../core/licensing';
import { CurrentSessionSection } from './sessions/CurrentSessionSection';
import { PersonalUpgradeSection } from './sessions/PersonalUpgradeSection';
import { ProSessionsSection } from './sessions/ProSessionsSection';
import { StartupSessionSection } from './sessions/StartupSessionSection';

export function SessionsSettingsTab() {
  const isProMode = useHasProAccess();

  return (
    <div className="space-y-6" data-testid="sessions-settings-tab">
      <StartupSessionSection />
      <CurrentSessionSection />
      {isProMode ? <ProSessionsSection /> : <PersonalUpgradeSection />}
    </div>
  );
}

